import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@playerbase/ui';

interface FeedbackEmptyStateProps {
  // The /feedback route is nested under /s/:studioShortId/g/:gameShortId, so we
  // need both slugs to build the link to game settings -> Discord.
  studioShortId: string;
  gameShortId: string;
}

export function FeedbackEmptyState({
  studioShortId,
  gameShortId,
}: FeedbackEmptyStateProps): JSX.Element {
  return (
    <EmptyState
      title="No feedback yet"
      description="Connect a Discord server and pick channels for the bot to watch. Posts will land here as they come in."
      cta={
        <Button asChild variant="primary" size="md">
          <Link to={`/s/${studioShortId}/g/${gameShortId}/game-settings/discord`}>
            Configure Discord
          </Link>
        </Button>
      }
    />
  );
}
